var ipaexplanations = {
  'b': 'as the "p" in "spud", unvoiced',
//  'c': 'a slender "k", made with spread lips, can also have a palatal offglide (like English "y")',
  'ç': 'a voiceless palatal fricative as in German ich',
  'd': 'as the "t" in stuff, unvoiced',
  'dʲ': 'like an unvoiced version of judge',
  'f': 'as the "f" in fit',
  'g': 'as the "k" in "skate", unvoiced',
  'gʲ': 'a palatalised "g"',
  'ɣ': 'a voiced guttural fricative like a continuous "g", not found in English',
  'h': 'as the "h" in "he"',
  'hʲ': 'a palatalised glide from a slender to a dark vowel like the "he" in "hew"',
  'ʰ': 'denotes an aspiration',
  'j': 'as the "y" in "yes"',
  'ʝ': 'as the "y" in "yes", but stronger, with more friction',
  'k': 'as the "c" in "cow"',
  'kʲ': 'a slender "k" with palatal offglide',
  'l': 'as the "l" in "lot"',
  'ʎ': 'a palatalised "l" as the "ll" in Spanish "pollo"',
  'Lʲ': 'a palatalised "l" as the "ll" in Spanish "pollo"',
  'ɫ': 'a dark "l", made by lowering the back of the tongue',
  'L': 'a dark "l", made by lowering the back of the tongue',
  'l̪ˠ': 'a dark "l", made by lowering the back of the tongue',
  'm': 'as the "m" in "mac"',
  'n': 'as the "n" in "no"',
  'ɲ': 'a palatalised "n" as the "ny" in "canyon", Spanish "cañon" or French "agneau"',
  'Nʲ': 'a palatalised "n" as the "ny" in "canyon", Spanish "cañon" or French "agneau"',
  'n̴': 'a dark "n", not found in English',
  'N': 'a dark "n", not found in English',
  'n̪ˠ': 'a dark "n", not found in English',
  'ŋ': 'a combined "n" and "g" as in "sing", "think"',
  'ŋʲ': 'a combined "n" and "g" as in "sing", "think" with an extra palatalisation, usually before [gʲ]',
  'p': 'as the "p" in put',
  'r': 'a tongue trilled "r"',
  'ɾ': 'a tongue trilled "r"',
  'ɾ´': 'an "r" like sound which is very varied in different dialects, it can range from "z" to "ð"',
  'rʲ': 'an "r" like sound which is very varied in different dialects, it can range from "z" to "ð"',
  'r´': 'an "r" like sound which is very varied in different dialects, it can range from "z" to "ð"',
  'ɾʲ': 'an "r" like sound which is very varied in different dialects, it can range from "z" to "ð"',
  'ᵲ': 'a dark "r", made by lowering the back of the tongue',
  'R': 'a dark "r", made by lowering the back of the tongue',
  'rˠ': 'a dark "r", made by lowering the back of the tongue',
  's': 'as the "s" in "sit"',
  'ʃ': 'as the "sh" in "she"',
  't': 'as the "t" in "top"',
  'tʲ': 'a palatalised "t"',
  'v': 'as the "v" in "very"',
  'x': 'an unvoiced fricative as in Scottish "loch" or German "ach"',
  'a': 'a clear "a" (not rounded or a diphtong, but the same quality throughout)',
  'ã': 'a nasalised "a" (not rounded or a diphtong, but the same quality throughout)',
  'ãː': 'a long nasalised "a" (not rounded or a diphtong, but the same quality throughout)',
  'ə': 'the "schwa", a central, neutral vowel, as the "a" in "another"',
  'ə̃': 'a nasalised "schwa", a central, neutral vowel, as the "a" in "another"',
  'aː': 'a long clear "a" (not rounded or a diphtong, but the same quality throughout)',
  'e': 'a clear "e" as the "e" in "pet" (not rounded or a diphtong, but the same quality throughout)',
  'eː': 'a long clear "e" as in Scottish "weight" (not rounded or a diphtong, but the same quality throughout)',
  'ẽ': 'a nasalised clear "e" (as the "e" in "pet"; not rounded or a diphtong, but the same quality throughout)',
  'ɛ': 'as the first "e" in "rebel"',
  'ɛː': 'a long version of "ɛ", which has the quality of the first "e" in "rebel"',
  'ɛ̃': 'a nasalised "ɛ", which has the quality of the first "e" in "rebel"',
  'ɛ̃ː': 'a long nasalised version of "ɛ", which has the quality of the first "e" in "rebel"',
  'i': 'a clear "i" between the "i" in "rid" and the "ee" in "reed", or the "i" in French "petit"',
  'iː': 'a long clear "i" as the "ee" in "reed"',
  'ĩ': 'a nasalised "i"',
  'ĩː': 'a long nasalised "i"',
  'ɪ': 'a short, unstressed "i" as the "i" in "rid"',
  'ɯ': 'an unrounded "u", made by putting the mouth in a "u" position and then spreading the lips',
  'ɯː': 'an long unrounded "u", made by putting the mouth in a "u" position and then spreading the lips',
  'ɯ̃': 'a nasalised unrounded "u", made by putting the mouth in a "u" position and then spreading the lips',
  'ɯ̃ː': 'a long nasalised unrounded "u", made by putting the mouth in a "u" position and then spreading the lips',
  'o': 'a clear "o" (not rounded or a diphtong, but the same quality throughout)',
  'oː': 'a long clear "o" as the "o" in Scottish "go", French "Merlot" (not rounded or a diphtong, but the same quality throughout)',
  'õ': 'a nasalised "o"',
  'ɔ': 'an open "o" as the "o" in "cord"',
  'ɔː': 'an long open "o" as the "o" in "born"',
  'ɔ̃': 'a nasalised open "o"',
  'ɔ̃ː': 'a long nasalised "o"',
  'ɤ': 'an unrounded "o"; this sound is produced by putting the mouth in an "o" position, then spreading the lips',
  'ɤ̃': 'a nasalised unrounded "o" (which is produced by putting the mouth in an "o" position, then spreading the lips)',
  'ɤː': 'an long unrounded "o"; this sound is produced by putting the mouth in an "o" position, then spreading the lips',
  'u': 'a clear "u" as the "ou" in "could"',
  'ũ': 'a nasalised clear "u" (as the "ou" in "could")',
  'uː': 'a long clear "u" as the "oo" in "boon"',
  'ũ': 'a nasalised "u"',
  'ũː': 'a long nasalised "u"',
  'ʊ': 'a short, unstressed "u" as the "u" in "put"',
  //'ʊ': 'a nasalised short, unstressed "u"',
  '.': 'separates two vowels by a glottal stop as in "go on"',
  'ː': 'denotes that the preceding vowel is long',
  '\'': 'a stress marker - the word stress is on the syllable following this marker'
}

export default ipaexplanations;



// WEBPACK FOOTER //
// ./src/ipaexplanations.js